import {
  useDeleteOrderLineOtcShipToMutation,
  useUpdateOrderLineOtcShipToMutation
} from "@saleor/graphql";
import useNotifier from "@saleor/hooks/useNotifier";
import { FormikProps } from "formik";
import { isEqual } from "lodash-es";

import { otcShipToMapping, otcSplitNameAddress } from "../utils";

interface Props {
  formikItemDetails: FormikProps<{ lines: NotRefOrderLine[] }>;
  shipToModal: any;
  formikHeader: FormikProps<NotRefOrderHeader>;
}

function useOrderLineShipTo({
  formikItemDetails,
  shipToModal,
  formikHeader
}: Props) {
  const notify = useNotifier();

  const [updateOTCLineShipTo] = useUpdateOrderLineOtcShipToMutation();
  const [deleteOTCLineShipTo] = useDeleteOrderLineOtcShipToMutation();

  const handleShipToSubmit = (index, name, value) => {
    if (formikHeader?.values?.shipTo === value) {
      return;
    }
    formikItemDetails.handleChange({
      target: { name: `lines[${index}].${name}`, value }
    });
  };

  const handleOTCShipTO = (index, name, Deletename, value) => {
    let id = "";
    const payload = { ...value };
    if (payload?.id) {
      delete payload.id;
    }
    if (isEqual(payload, otcShipToMapping(formikHeader?.values?.otcShipTo))) {
      return;
    }
    updateOTCLineShipTo({
      variables: {
        lineId: formikItemDetails?.values?.lines?.[index]?.id || "",
        otcShipTo: otcSplitNameAddress({ ...payload })
      }
    }).then(({ data, errors }) => {
      if (data?.updateOrderLineOtcShipTo?.id) {
        id = data?.updateOrderLineOtcShipTo?.id;
        const otc = { ...value, id };
        handleShipToSubmit(index, name, otc);
        handleShipToSubmit(shipToModal.index, Deletename, null);
      }
      if (errors) {
        notify({
          status: "error",
          apiMessage: "Response not successful: Received status code 400"
        });
      }
    });
  };

  const deleteOtcShipTo = (index, name, otc) => {
    if (formikItemDetails?.values?.lines?.[index]?.otcShipTo?.id) {
      deleteOTCLineShipTo({
        variables: {
          lineId: formikItemDetails?.values?.lines?.[index]?.id
        }
      }).then(({ errors }) => {
        if (!errors) {
          handleShipToSubmit(index, name, otc);
        }
        if (errors) {
          notify({
            status: "error",
            apiMessage: "Response not successful: Received status code 400"
          });
        }
      });
    } else {
      handleShipToSubmit(index, name, otc);
    }
  };
  return { handleOTCShipTO, deleteOtcShipTo, handleShipToSubmit };
}

export default useOrderLineShipTo;
